var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicAndDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.21655 5.21704L21.2663 7.892L21.2663 7.89202L23.8376 14.7487L14.7482 23.8381L7.89154 21.2668L5.21655 5.21704ZM11.5903 12.5553C11.2057 13.1308 11.0004 13.8075 11.0004 14.4998C11.0004 14.9594 11.091 15.4145 11.2668 15.8392C11.4427 16.2638 11.7005 16.6496 12.0256 16.9746C12.3506 17.2996 12.7364 17.5575 13.161 17.7333C13.5857 17.9092 14.0408 17.9998 14.5004 17.9998C15.1927 17.9998 15.8694 17.7945 16.4449 17.4099C17.0205 17.0253 17.4691 16.4787 17.734 15.8392C17.9989 15.1996 18.0682 14.4959 17.9332 13.8169C17.7981 13.138 17.4648 12.5144 16.9753 12.0249C16.4858 11.5354 15.8622 11.2021 15.1832 11.067C14.5043 10.932 13.8006 11.0013 13.161 11.2662C12.5215 11.5311 11.9749 11.9797 11.5903 12.5553Z",
    stroke: "#9199A3",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5C12 15.8807 13.1193 17 14.5 17C15.8807 17 17 15.8807 17 14.5C17 13.1193 15.8807 12 14.5 12C13.1193 12 12 13.1193 12 14.5Z",
    stroke: "#9199A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99781 4.00098L12.7305 12.7325",
    stroke: "#9199A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.00098L6.90513 21.4317C6.93398 21.6048 7.00787 21.7672 7.11938 21.9027C7.23089 22.0382 7.37609 22.142 7.5404 22.2036L15 25.001L25 15.001L22.2026 7.54137C22.141 7.37706 22.0373 7.23186 21.9018 7.12035C21.7663 7.00884 21.6038 6.93495 21.4307 6.9061L4 4.00098Z",
    stroke: "#9199A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 25.001L18.293 28.2939C18.3859 28.3867 18.4961 28.4604 18.6175 28.5106C18.7388 28.5609 18.8688 28.5868 19.0001 28.5868C19.1315 28.5868 19.2615 28.5609 19.3828 28.5106C19.5042 28.4604 19.6144 28.3867 19.7073 28.2939L28.293 19.7081C28.4806 19.5205 28.5859 19.2662 28.5859 19.001C28.5859 18.7358 28.4806 18.4814 28.293 18.2939L25.0001 15.001",
    stroke: "#9199A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicAndDesign);
export default __webpack_public_path__ + "static/media/graphic-and-design.e0e5e292bd9c1f27b1123715a717eaea.svg";
export { ForwardRef as ReactComponent };